export const GUIDES = [
  {
    slug: "esim",
    category: "Connectivity",
    title: "Connectivity & eSIMs for full-time nomads",
    summary: "Airalo, Holafly, Nomad and Revolut eSIM compared on coverage, price, unlimited data and the fine print.",
    readMinutes: 6,
    ready: true,
  },
  {
    slug: "visas",
    category: "Visas",
    title: "Europe visas & the 90/180-day rule",
    summary: "How the Schengen 90/180-day rule works (90 days in any 180), which European countries run their own clock, and where digital nomad visas let you stay longer.",
    readMinutes: 7,
    ready: true,
  },
  { slug: "visas-asia", category: "Visas", title: "Asia visas for nomads", summary: "Visa-free stays, visa runs and remote-work visas across Asia.", ready: false },
  { slug: "insurance", category: "Insurance", title: "Insurance for full-time nomads", summary: "Health and travel cover when you have no fixed home.", ready: false },
  { slug: "banking", category: "Money", title: "Banking on the road", summary: "Cards, accounts and fees that work across borders.", ready: false },
  { slug: "vpn", category: "Security", title: "VPN for travel", summary: "Staying safe on public Wi-Fi and reaching home services.", ready: false },
];

export const READY_GUIDES = GUIDES.filter((g) => g.ready);
